import { setWorkerUrl } from 'maplibre-gl';
// `?worker&url` makes Vite bundle the worker (it imports a sibling chunk, so
// copying the file alone would break) and hand back a URL for it.
import maplibreWorkerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url';

/**
 * Points MapLibre at its own web worker.
 *
 * MapLibre locates the worker itself with
 * `new URL(`./${name}`, import.meta.url)` where `name` is chosen at runtime.
 * No bundler can see through that, so the worker chunk is never emitted and the
 * request 404s — in Vite's dev server *and* in the production build, where the
 * URL resolves next to the hashed entry bundle.
 *
 * The failure is silent and easy to misread: MapLibre raises no error, the map
 * simply renders nothing but raster layers, because vector tiles are decoded in
 * that worker. Radar (raster) kept working while the whole basemap stayed
 * blank.
 *
 * Importing this module for its side effect, before any map is constructed,
 * replaces the guess with a URL the bundler actually emitted.
 */
setWorkerUrl(maplibreWorkerUrl);
